import "./textPage/text-page.ts"
import "./forms.ts"
import select from "./xpage/select"

declare global {
	interface Window {
		$: Function;
		is: any;
		requestIdleCallback: Function;
		cancelIdleCallback: Function;
		defaultSlideInit: Function;
		swiperThumbsReady: any;
		notificator: any;
		selectInitial: Function;
	}
}

window.selectInitial = (targetSelect: HTMLSelectElement) => new select(targetSelect);
